<template>
  <div
    :class="`category-${$route.params.category}`"
    class="ressort-title"
    style="color: var(--category-color)"
  >
    <h1 v-if="!$slots.default">
      {{ ressortName }}
    </h1>
    <slot></slot>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    ressortName: {
      type: String,
      required: false,
      default() {
        return this.$route.params.category
      },
    },
  },
}
</script>

<style scoped>
@import '~components/content/widgets/listings/RessortTitle.css';
</style>
